/**
 * D1–D4 do atendimento — o AVISO DO PLANTÃO no Portal, acima do botão de enviar o chamado. Só fora do horário de
 * funcionamento (o servidor decide e devolve `null` dentro dele): o chamado foi recebido, quando será atendido e o
 * telefone do plantão, que no celular liga direto. Falha ao ler = nada aparece (o formulário nunca depende disto).
 */
import { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';

import { clienteApi } from '@/lib/cliente-api';

interface Aviso {
  atendimento: string;
  telefone: string | null;
}

export function AvisoDoPlantao() {
  const [aviso, setAviso] = useState<Aviso | null>(null);

  useEffect(() => {
    let vivo = true;
    Promise.resolve()
      .then(() => clienteApi.get<{ aviso: Aviso | null }>('/plantao'))
      .then((r) => vivo && setAviso(r?.aviso ?? null))
      .catch(() => vivo && setAviso(null));
    return () => {
      vivo = false;
    };
  }, []);

  if (!aviso) return null;
  return (
    <div className="rounded-xl border border-line bg-paper-warm px-4 py-3 text-sm text-ink-1 dark:border-line-dark dark:bg-paper-dark-warm dark:text-ink-dark-1" data-testid="aviso-do-plantao">
      <p>
        Estamos fora do horário de atendimento. O chamado fica registrado e será atendido <strong>{aviso.atendimento}</strong>.
      </p>
      {aviso.telefone ? (
        <a href={`tel:${aviso.telefone.replace(/[^\d+]/g, '')}`} className="mt-2 inline-flex min-h-[44px] items-center gap-2 font-semibold underline">
          <Phone className="h-4 w-4" aria-hidden />
          Urgência: ligue para o plantão, {aviso.telefone}
        </a>
      ) : null}
    </div>
  );
}
